var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiplatformReach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.269 55.0001C121.728 55.0001 136.186 54.9908 150.645 55.0048C155.612 55.0094 159.308 57.7302 160.518 62.1625C160.81 63.2415 160.819 64.3438 160.819 65.4414C160.829 74.6642 160.792 83.887 160.856 93.1098C160.866 94.5516 160.485 95.0492 159.029 94.933C157.476 94.8074 155.909 94.8818 154.346 94.9097C150.126 94.9888 146.889 98.17 146.769 102.384C146.713 104.412 146.713 106.444 146.764 108.472C146.787 109.453 146.439 109.825 145.461 109.788C144.019 109.737 142.572 109.774 141.125 109.774C120.072 109.774 99.0238 109.746 77.9709 109.821C76.1531 109.825 75.7775 109.295 75.796 107.583C75.8841 100.044 75.8749 92.5005 75.8239 84.9614C75.7682 77.2222 70.7739 72.2736 63.0901 72.2411C60.5442 72.2318 57.9984 72.2411 55.4572 72.2411C53.9517 72.2411 53.1989 71.5016 53.1989 70.0226C53.1989 68.4552 53.1896 66.8925 53.1989 65.3252C53.236 59.0557 57.2564 55.0187 63.5445 55.0094C78.1193 54.9908 92.6941 55.0048 107.269 55.0048V55.0001Z",
    fill: "url(#paint0_linear_14_217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 111.857C25 102.867 25 93.877 25 84.8868C25 80.501 27.5458 77.7755 31.9419 77.7476C42.4081 77.6779 52.8743 77.6825 63.3405 77.7476C67.7551 77.7755 70.3891 80.5707 70.3937 85.031C70.4076 102.895 70.4076 120.759 70.3937 138.619C70.3937 143.209 67.6346 145.972 63.0298 145.981C52.7955 146.005 42.5611 146.005 32.3222 145.981C27.6618 145.972 24.9954 143.274 24.9954 138.651C24.9954 129.722 24.9954 120.787 24.9954 111.857H25ZM47.7316 134.605C46.7485 134.605 45.7608 134.554 44.7824 134.619C43.2428 134.721 42.0742 135.866 42.1067 137.289C42.1438 138.814 42.9785 139.921 44.4809 140.042C46.6048 140.21 48.7611 140.205 50.8803 140.037C52.4477 139.912 53.3102 138.614 53.1525 137.079C52.9902 135.503 51.9979 134.735 50.5 134.619C49.5819 134.545 48.6498 134.605 47.727 134.61L47.7316 134.605Z",
    fill: "url(#paint1_linear_14_217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.94 118.095C174.94 123.141 174.912 128.187 174.963 133.233C174.972 134.27 174.726 134.629 173.623 134.619C166.913 134.568 160.207 134.573 153.497 134.619C152.403 134.629 152.134 134.243 152.139 133.215C152.166 123.238 152.143 113.262 152.166 103.286C152.171 101.193 152.931 100.472 155.009 100.467C160.736 100.454 166.458 100.454 172.185 100.467C174.314 100.472 174.935 101.128 174.94 103.305C174.949 108.235 174.94 113.165 174.94 118.095Z",
    fill: "url(#paint2_linear_14_217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.902 145.991C99.3902 145.991 91.8779 145.991 84.361 145.991C83.4335 145.991 82.5061 146 81.6899 145.46C80.5863 144.726 80.2709 143.661 80.5492 142.428C80.8367 141.135 81.7873 140.414 83.0208 140.349C85.2699 140.228 87.5328 140.163 89.7772 140.317C91.4374 140.428 92.0958 139.893 92.3555 138.252C92.8053 135.461 93.5427 132.712 94.0528 129.931C94.229 128.954 94.6649 128.736 95.5598 128.736C103.188 128.759 110.816 128.778 118.444 128.717C119.618 128.708 119.901 129.206 120.091 130.182C120.643 133.019 121.306 135.833 121.839 138.67C122.071 139.893 122.572 140.386 123.884 140.303C125.957 140.177 128.044 140.247 130.126 140.275C132.398 140.303 133.678 141.396 133.636 143.209C133.594 144.949 132.352 145.972 130.144 145.977C122.4 145.995 114.656 145.986 106.912 145.986L106.902 145.991Z",
    fill: "url(#paint3_linear_14_217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.275 115.211C122.488 115.211 133.701 115.234 144.914 115.183C146.314 115.178 146.894 115.504 146.783 117.001C146.657 118.671 146.718 120.364 146.764 122.043C146.787 122.941 146.449 123.336 145.558 123.262C145.271 123.238 144.979 123.262 144.691 123.262C122.442 123.262 100.188 123.243 77.9384 123.299C76.3015 123.299 75.6245 122.941 75.8099 121.211C75.9583 119.834 75.9259 118.425 75.8146 117.043C75.6987 115.606 76.1809 115.178 77.6416 115.183C88.8544 115.243 100.067 115.215 111.28 115.215L111.275 115.211Z",
    fill: "url(#paint4_linear_14_217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.495 140.145C166.732 140.145 169.973 140.228 173.205 140.107C174.712 140.052 175.167 140.563 174.954 141.963C174.884 142.414 174.926 142.889 174.944 143.354C175.019 145.009 174.151 145.94 172.593 145.954C166.579 146.014 160.569 146.019 154.555 145.954C152.862 145.935 152.166 144.977 152.166 142.986C152.166 139.512 151.851 140.2 154.823 140.159C157.712 140.117 160.606 140.149 163.495 140.149V140.145Z",
    fill: "url(#paint5_linear_14_217)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_217",
    x1: 107.026,
    y1: 54.9971,
    x2: 107.026,
    y2: 109.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_217",
    x1: 47.6997,
    y1: 77.697,
    x2: 47.6997,
    y2: 145.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_217",
    x1: 163.551,
    y1: 100.457,
    x2: 163.551,
    y2: 134.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_217",
    x1: 107.045,
    y1: 128.717,
    x2: 107.045,
    y2: 145.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_217",
    x1: 111.288,
    y1: 115.183,
    x2: 111.288,
    y2: 123.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_217",
    x1: 163.58,
    y1: 140.103,
    x2: 163.58,
    y2: 146.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 91,
    fill: "white",
    transform: "translate(25 55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplatformReach);
export default __webpack_public_path__ + "static/media/Multiplatform_Reach.d4771871f69b69f8371d2d53fdd1a388.svg";
export { ForwardRef as ReactComponent };